<style lang="postcss">
	.field-error {
		-webkit-text-stroke: 0.25px;
		left: 0px;
		display: flex;
		flex-direction: row;
		padding: 1px 0px;
		font-size: 0.7rem;
		align-items: center;
		line-height: 1.15;
		min-height: 1.05rem;
	}
	.field-error-svg {
		margin-right: 3px;
		height: 100%;
		width: 6px;
		opacity: 0.85;
	}
	@media (max-width: 768px) {
		.field-error {
			padding-top: 4px;
			font-size: 13px;
		}
		.field-error-svg {
			width: 8px;
		}
	}
</style>

<script lang="ts">
	import { getContext } from "svelte";
	import type { t as tBase } from "$lib/helpers/translate";
	const t = getContext<typeof tBase>("t");
	export let errorType: ErrorTypes;
	export let errorNumber: number | string;
	export let valid: boolean;
	export let visible: boolean = false;
</script>

<div class="field-error">
	{#if errorType && valid === false && visible === true}
		<svg
			class="field-error-svg"
			viewBox="0 0 48 48"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="26" cy="26" r="16"></circle>
		</svg>
		{t.get(errorType, errorNumber)}
	{/if}
</div>
